var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"10px","background-color":"#F5F5F5","min-height":"100vh"}},[_c('div',{staticStyle:{"width":"700px","margin":"auto","background-color":"#fff","padding":"20px","box-shadow":"0 2px 12px 0 rgba(0, 0, 0, 0.1)"}},[_c('ApplyDetailInfo',{attrs:{"id":_vm.id}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f025fa10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/oem/OpenApply.vue
// module id = null
// module chunks = 